import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Deaktivierte Version des CartDrawerComponent – ersetzt Drawer durch leeres Verhalten.
 * Drawer wird **nicht** geöffnet, Event-Handler bleibt sauber registriert.
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    // Event wird nicht mehr behandelt – Drawer öffnet sich nicht
    // document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Event wird nicht mehr entfernt, weil es nie registriert wurde
    // document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  // Diese Methode wird nie mehr aufgerufen, bleibt nur als Fallback vorhanden
  #handleCartAdd = () => {
    // Drawer wird NICHT mehr angezeigt
    // this.showDialog();
  };

  open() {
    // Drawer manuell öffnen → deaktiviert
    // this.showDialog();
  }

  close() {
    // Drawer manuell schließen → deaktiviert
    // this.closeDialog();
  }
}

// Registrierung bleibt, damit das Custom Element nicht fehlt
if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
